/**
 * Collection of external URLs used throughout the application
 */

export const socialLinks = {
  github: 'https://github.com/archil-l',
  linkedin: 'https://www.linkedin.com/in/archil-l/',
  resume: 'https://1drv.ms/b/c/21c15a5e07446ee2/EUFsXnrsGAhPtOYfzk-WwkgBq_HwdXPCTG5MY7_GA8wC_w',
};
